module.exports = __webpack_public_path__ + "static/media/my-face.484e84bb.jpg";